module.exports = __webpack_public_path__ + "img/IMG-20200311-WA0031.0e8802fe.jpg";